import { ILayoutProperties } from "../theme.types";

export const layoutProperties: ILayoutProperties = {
  outageDrawerWidth: 375,
  headerHeight: 75,
  logoWidthDesktop: 125,
  logoWidthMobile: 30,
};
